module.exports = __webpack_public_path__ + "fonts/OpenSans-Light.ed41bed.ttf";